export const DISCORD_ENABLED = true;
